import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./Component/Layout/Layout";
import Home from "./Pages/Home/Home";
import Contact from "./Pages/ContactUs/ContactUs";
import Service from "./Pages/Service/Service";
import ServiceBook from "./Pages/Service/ServiceBook";
import ServiceDetails from "./Pages/Service/ServiceDetails";
import PaymentRedirect from "./Pages/Service/PaymentRedirect";
import Notfound from "./Pages/Notfound";
import ScrollToTop from "./Pages/ScrollToTop";
// import Consultant from './Pages/Consultants/Consultant';
// import Chatbox from './Pages/Chatbox/Chatbox';
import Consultant from "./Pages/Consultants/Consultant";
import Blog from "./Pages/Blog";
import BlogDetail from "./Pages/Home/BlogDetail";
import BlogDetailnew from "./Pages/Home/Blog/BlogDetail";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

function App() {
  const queryClient = new QueryClient();
  return (
    <>
      <BrowserRouter>
        <QueryClientProvider client={queryClient}>
          <ScrollToTop />
          <Routes>
            <Route
              path="/"
              element={
                <Layout>
                  <Home />
                </Layout>
              }
            />
            {/* <Route path="/:id" element={<Layout><Home /></Layout>} /> */}
            <Route
              path="/contact"
              element={
                <Layout>
                  <Contact />
                </Layout>
              }
            />
            <Route
              path="/blog/:id"
              element={
                <Layout>
                  <Blog />
                </Layout>
              }
            />
            <Route
              path="/blogdetails/:id"
              element={
                <Layout>
                  <BlogDetail />
                </Layout>
              }
            />
            <Route
              path="/blog-detail/:id"
              element={
                <Layout>
                  <BlogDetailnew />
                </Layout>
              }
            />
            <Route
              path="/service"
              element={
                <Layout>
                  <Service />
                </Layout>
              }
            />
            <Route
              path="/service-detail/:id"
              element={
                <Layout>
                  <ServiceDetails />
                </Layout>
              }
            />
            <Route
              path="/service-Book/:id"
              element={
                <Layout>
                  <ServiceBook />
                </Layout>
              }
            />
            <Route
              path="/consultant"
              element={
                <Layout>
                  <Consultant />
                </Layout>
              }
            />
            {/* <Route path="/Chatbox/:id" element={<Layout><Chatbox /></Layout>} /> */}
            <Route path="/payment-redirect" element={<PaymentRedirect />} />
            <Route path="*" element={<Notfound />} />
          </Routes>
        </QueryClientProvider>
      </BrowserRouter>
    </>
  );
}

export default App;
